/**
 * PURPOSE: Consumir endpoints Hayllis V2 de medallero desde Winscore.
 * RESPONSIBILITIES: Editar medallas por deporte y administrar la consolidación del resumen general.
 * COLLABORATORS: MedalTableArea, MedalSportEditor y MedalConsolidationEditor.
 * ROUTE: src/services/hayllisV2MedalService.js
 */
import axios from "axios";
import API_BASE_URL from "../config/config.js";

const basePath = (idevent) => `${API_BASE_URL}/api/hayllis/v2/events/${idevent}/medals`;

export const getEventMedalEditor = async ({ idevent, idsport }) => {
  const response = await axios.get(`${basePath(idevent)}/editor`, { params: idsport ? { idsport } : {} });
  return response.data?.data || response.data;
};

export const updateEventMedalsBulk = async ({ idevent, idsport, items }) => {
  const response = await axios.patch(`${basePath(idevent)}/bulk`, { idsport: Number(idsport), items });
  return response.data?.data || response.data;
};

export const getMedalConsolidationEditor = async ({ idevent }) => {
  const response = await axios.get(`${basePath(idevent)}/consolidation/editor`);
  return response.data?.data || response.data;
};

export const searchMedalConsolidationInstitutions = async ({ idevent, search }) => {
  const response = await axios.get(`${basePath(idevent)}/consolidation/institutions`, { params: { search } });
  return response.data?.data || response.data;
};

export const updateMedalConsolidationBulk = async ({ idevent, items }) => {
  const response = await axios.patch(`${basePath(idevent)}/consolidation/bulk`, { items });
  return response.data?.data || response.data;
};
